import React from 'react';
import { Mailbox } from 'lucide-react';
import { MarkSentPanel } from '../components/MailingBatchPanel';

// "Post" (Talu, 18.10.2026): the post-office step lives here for the whole team — what is physically mailed gets ticked off.
export default function PostPage() {
  return (
    <div className="space-y-6 max-w-4xl" data-testid="post-page">
      <div>
        <h1 className="font-heading text-2xl text-foreground tracking-tight flex items-center gap-2">
          <Mailbox className="w-6 h-6 text-emerald-400" strokeWidth={1.5} /> Post
        </h1>
        <p className="text-sm text-muted-foreground mt-1">
          Alles, was produziert ist und zur Post geht, hier als versendet markieren — Deals wandern nach „Contacted", Follow-up-Sequenzen starten automatisch.
        </p>
      </div>
      <MarkSentPanel />
    </div>
  );
}
